import {
  LdLabel,
  LdSelect,
  LdTableHeader,
  LdTableRow,
} from "@emdgroup-liquid/liquid/dist/react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { pxToRem } from "@src/utils";

const StyledCodons = styled.div`
  font-family: monospace;
  letter-spacing: 2px;
`;

const StyledSpanCodon = styled.span<{}>`
  border: 1px solid #e1e1e1;

  &:not(:last-of-type) {
    border-right: 0;
  }
`;
const StyledTableLabel = styled(LdLabel)`
  width: 100%;
  margin: 10px 0 10px 2px;

  &.ld-label::part(tag) {
    font-weight: bold;
  }
`;

const StyledTableRow = styled(LdTableRow) <{ scope?: string }>`
  ::part(row) {
    position: relative;
  }

  ${({ scope }) => {
    if (scope === "down") {
      return css`
        ::part(root) {
          visibility: hidden;
        }
      `;
    }
    return css`
      ::part(cell) {
        vertical-align: middle;
      }
    `;
  }}
`;

const StyledTableHeader = styled(LdTableHeader) <{ scope?: string }>`
  ::part(row) {
    position: relative;
  }

  ${({ scope }) => {
    if (scope === "down") {
      return css`
        ::part(input) {
          display: none;
        }
      `;
    }
    if (scope === "centeralign") {
      return css`
        ::part(cell) {
          vertical-align: middle;
          position: relative;
          z-index: 9;
          background-color: white;
          border: var(--ld-table-row-outline-half);
          text-align: center;
        }
      `;
    }
    return css`
      ::part(cell) {
        vertical-align: middle;
        position: relative;
        z-index: 9;
        background-color: white;
        border: var(--ld-table-row-outline-half);
      }
    `;
  }}
`;

const StyledSelect = styled(LdSelect) <{ width?: number | string }>`
  width: ${({ width }) => width || "auto"};
  padding-top: ${pxToRem(10)};
  padding-bottom: ${pxToRem(10)};

  &::part(root) {
    width: auto;
    min-width: 90px;
  }
  &[role="button"] {
    ::part(div) {
     border: 1px solid #503291;
    background: #8255e4;
    }
  
`;

const StyledDiv = styled.div`
  margin-left: auto;
`;

const StyledLabel = styled(LdLabel)`
  width: auto;
  margin-right: ${pxToRem(10)};
`;

const StyledWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export {
  StyledCodons,
  StyledSpanCodon,
  StyledTableLabel,
  StyledTableRow,
  StyledTableHeader,
  StyledSelect,
  StyledDiv,
  StyledLabel,
  StyledWrapper,
};
